const SHOPIFY_DOMAIN = "https://dev-markslojd.myshopify.com/";
const STOREFRONT_TOKEN = "3ec07cff92b9482feb0b1a46e68b2c46";
const FALLBACK_COLLECTION_HANDLE = window.fallbackCollection;
// console.log(FALLBACK_COLLECTION_HANDLE);
const cartupsell_heading = window.cartupsell_heading;
const btn_addtocart = window.addtocart;
async function renderUpsellProducts(products) {
  // console.log(products);
  const container = document.querySelector("#cart-drawer-upsell");
  const container_mobile = document.querySelector("#cart-drawer-upsell-mobile");
  if (!container && !container_mobile) return;
  const inStockProducts = products.filter((p) => {
    const variant = p.variants?.nodes?.[0];
    return variant?.availableForSale === true;
  });
  if (!inStockProducts.length) {
    await renderFallbackCollection();
    return;
  }

  const heading = `<div class="upsell_heading">${cartupsell_heading}</div>`;

  function formatPrice(amount, currency, country) {
    const number = amount.toFixed(2); // "1234.56"
    let [intPart, decimalPart] = number.split(".");

    if (country === "PL") {
      intPart = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
      return `${intPart},${decimalPart} zł`;
    }

    if (country === "FI" || country === "DE") {
      intPart = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      return `€${intPart},${decimalPart}`;
    } else if (country === "SE" || country === "DK") {
      intPart = Math.round(amount)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, " ");
      return `${intPart} kr`;
    }

    return `${number} ${currency}`;
  }

  const countryCode = Shopify.country;

  const productsHtml = inStockProducts
    .map((p) => {
      const variant = p.variants.nodes[0];
      const variantId = variant?.id.split("/").pop();

      const price = parseFloat(variant?.price?.amount);
      const compareAtPrice = parseFloat(variant?.compareAtPrice?.amount || 0);
      const isDiscounted = compareAtPrice > price;

      // Decide class names based on discount presence
      const mainPriceClass = isDiscounted
        ? "main-price main-price_red"
        : "main-price main-price_black";
      const comparePriceClass = "compare-price main-price_black";

      return `
      <div class="upsell-product">
        <span class="upsell_img_wrapper">
          <img class="upsell_image" src="${p.featuredImage?.url}" alt="${
        p.featuredImage?.altText || p.title
      }" width="${p.featuredImage?.width || 200}" height="${
        p.featuredImage?.height || 200
      }" />
        </span>
        <div class="upsell_product_info">
          <a class="upsell_url" href="/products/${p.handle}">
            <span class="upsell_title" title="${p.title}">${p.title}</span>
          </a>
          <div class="upsell_inline">
          <div class="price-info">
            <span class="${mainPriceClass}">${formatPrice(
        price,
        variant?.price?.currencyCode,
        countryCode
      )}</span>
            ${
              isDiscounted
                ? `<span class="${comparePriceClass}">${formatPrice(
                    compareAtPrice,
                    variant?.price?.currencyCode,
                    countryCode
                  )}</span>`
                : ""
            }
          </div>
          <div class="upsell_btn">
            <button class="upsell-add-to-cart" data-variant-id="${variantId}">${btn_addtocart}</button>
          </div>
          </div>
        </div>
      </div>
    `;
    })
    .join("");

  container.innerHTML = heading + productsHtml;
  container_mobile.innerHTML =
    heading + "<div class='upsell_slider_mobile'>" + productsHtml + "</div>";

  attachUpsellAddToCartEvents();
}
async function fetchComplementaryProductsByHandle(productHandle) {
  const query = `
    query getProductComplementary($handle: String!) @inContext(country: ${
      Shopify.country
    }, language: ${Shopify.locale.toUpperCase()}) {
  product(handle: $handle) {
    metafield(namespace: "shopify--discovery--product_recommendation", key: "complementary_products") {
      references(first: 10) {
        nodes {
          ... on Product {
            id
            title
            handle
            variants(first: 1) {
              nodes {
                id
                availableForSale
                price {
                  amount
                  currencyCode
                }
                compareAtPrice {
                  amount
                  currencyCode
                }
              }
            }
            featuredImage {
              url
              altText
              width
              height
            }
          }
        }
      }
    }
  }
}
  `;

  const response = await fetch(`${SHOPIFY_DOMAIN}/api/2024-04/graphql.json`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Shopify-Storefront-Access-Token": STOREFRONT_TOKEN,
    },
    body: JSON.stringify({
      query,
      variables: { handle: productHandle },
    }),
  });

  const json = await response.json();
  return json?.data?.product?.metafield?.references?.nodes || [];
}
async function handleUpsellUpdate() {
  const cartRes = await fetch("/cart.js");
  const cart = await cartRes.json();
  const cartItems = cart.items || [];

  if (cartItems.length === 0) {
    const cartUpsell = document.querySelector("#cart-drawer-upsell");
    const container_mobile = document.querySelector("#cart-drawer-upsell-mobile");

    if (cartUpsell) {
      cartUpsell.style.display = "none";
      cartUpsell.innerHTML = "";
    }

    if (container_mobile) {
      container_mobile.style.display = "none";
      container_mobile.innerHTML = "";
    }

    return;
  }

  
  const cartProductIds = cartItems.map((item) => item.product_id.toString());
  let allComplementaryProducts = [];

  for (const item of cartItems) {
    const products = await fetchComplementaryProductsByHandle(item.handle);

    if (Array.isArray(products)) {
      products.forEach((p) => {
        const productId = p.id.split("/").pop();
        if (!cartProductIds.includes(productId)) {
          allComplementaryProducts.push(p);
        }
      });
    }
  }

  
  const uniqueProductsMap = new Map();
  allComplementaryProducts.forEach((product) => {
    if (!uniqueProductsMap.has(product.id)) {
      uniqueProductsMap.set(product.id, product);
    }
  });

  const finalUpsellList = Array.from(uniqueProductsMap.values());

  if (finalUpsellList.length > 0) {
    renderUpsellProducts(finalUpsellList);
  } else {
    await renderFallbackCollection();
  }
}


async function renderProductsByHandles(handles) {
  const query = `
    query getProducts($first: Int!) @inContext(country: ${
      Shopify.country
    }, language: ${Shopify.locale.toUpperCase()}){
      products(first: $first) {
        nodes {
          title
          handle
          variants(first: 1) {
              nodes {
                id
                availableForSale
                price {
                  amount
                  currencyCode
                }
                compareAtPrice {
                  amount
                  currencyCode
                }
              }
            }
          featuredImage {
              url
              altText
              width
              height
            }
        }
      }
    }
  `;

  const res = await fetch(`${SHOPIFY_DOMAIN}/api/2024-04/graphql.json`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Shopify-Storefront-Access-Token": STOREFRONT_TOKEN,
    },
    body: JSON.stringify({
      query,
      variables: { first: 50 },
    }),
  });

  const json = await res.json();
  const allProducts = json?.data?.products?.nodes || [];

  const exactMatches = allProducts.filter((p) => handles.includes(p.handle));

  renderUpsellProducts(exactMatches);
}

async function renderFallbackCollection() {
  if (!Array.isArray(window.colList) || window.colList.length === 0) {
    console.warn("No fallback data found in window.colList");
    return;
  }

  const heading = `<div class="upsell_heading">${cartupsell_heading}</div>`;

  const fallbackHtml = window.colList
    .map((col) => {
      return `
        <div class="upsell-product fallback">
        <a href="${col.collection_url}">
          <span class="upsell_img_wrapper">
            <img class="upsell_image" src="${col.collection_image}" alt="${col.title}" width="${col.img_width}" height="${col.img_height}" />
          </span>
            <div class="upsell_product_info">
              <span class="upsell_title">${col.title}</span>
            </div>
          </a>
        </div>
      `;
    })
    .join("");

  const container = document.querySelector("#cart-drawer-upsell");
  const container_mobile = document.querySelector("#cart-drawer-upsell-mobile");
  if (container) {
    container.innerHTML = heading + fallbackHtml;
    container_mobile.innerHTML =
      heading + "<div class='upsell_slider_mobile'>" + fallbackHtml + "</div>";
  }
}

function reloadCartDrawerHTML() {
  fetch("/?sections=cart-drawer")
    .then((res) => res.json())
    .then((data) => {
      const html = data["cart-drawer"];
      const currentDrawer = document.querySelector("cart-drawer");

      if (!currentDrawer || !html) return;

      const temp = document.createElement("div");
      temp.innerHTML = html;

      const newDrawer = temp.querySelector("cart-drawer");
      if (newDrawer) {
        currentDrawer.innerHTML = newDrawer.innerHTML;

        attachUpsellAddToCartEvents();
        handleUpsellUpdate();
      }
    });
}

function attachUpsellAddToCartEvents() {
  document.querySelectorAll(".upsell-add-to-cart").forEach((btn) => {
    btn.addEventListener("click", async (e) => {
      e.preventDefault();
      const variantId = btn.dataset.variantId;
      if (!variantId) return;

      showUpsellLoader();

      await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      });

      document.querySelector("cart-drawer")?.classList.add("is-open");

      setTimeout(() => {
        reloadCartDrawerHTML();
        hideUpsellLoader();
      }, 700);
    });
  });
}

document.addEventListener("DOMContentLoaded", async () => {
  await handleUpsellUpdate();

  const cartDrawer = document.querySelector("cart-drawer");
  if (cartDrawer) {
    const observer = new MutationObserver(async () => {
      if (cartDrawer.classList.contains("is-open")) {
        await handleUpsellUpdate();
      }
    });

    observer.observe(cartDrawer, {
      attributes: true,
      attributeFilter: ["class"],
    });

    checkSelectedURLChange(async () => {
      await handleUpsellUpdate();
    });
  }
});

function showUpsellLoader(cb) {
  const loader = document.getElementById("upsell-loader");
  if (loader) loader.style.display = "flex";
  if (cb) {
    cb();
  }
}

function hideUpsellLoader() {
  const loader = document.getElementById("upsell-loader");
  if (loader) loader.style.display = "none";
}

function checkSelectedURLChange(callback) {
  var cartURL = ["update.js", "update", "add", "add.js", "change.js", "change"];
  const originalSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.send = function () {
    this.addEventListener("load", function () {
      const isTargetRequest = cartURL.some((pattern) =>
        this._url.includes(pattern)
      );

      if (isTargetRequest) {
        setTimeout(() => {
          callback();
        }, 100);
      }
    });

    return originalSend.apply(this, arguments);
  };

  const originalFetch = window.fetch;

  window.fetch = function (...fetchArgs) {
    const requestUrl = fetchArgs[0];

    return originalFetch.apply(this, fetchArgs).then((response) => {
      if (!response.ok) {
        return response;
      }

      try {
        const isTargetResponse = cartURL.some((pattern) =>
          response.url.includes(pattern)
        );

        if (isTargetResponse) {
          setTimeout(() => {
            callback();
          }, 100);
        }
      } catch (error) {
        console.warn(
          "[shop_events_listener] Error handling fetch request:",
          error.message
        );
      }

      return response;
    });
  };
}
